export default "__VITE_ASSET__SBYuXjsu__"